"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Behaviour = void 0;
/**
 * Represents behaviour information
 */
var Behaviour = /** @class */ (function (_super) {
    __extends(Behaviour, _super);
    function Behaviour() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Behaviour";
        /**
         * The behaviour id
         */
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        /**
         * The behaviour reference id
         */
        _this.reference = function () {
            _this.push(function (_) { return "reference"; });
        };
        /**
         * The name of the behaviour
         */
        _this.qualifier = function () {
            _this.push(function (_) { return "qualifier"; });
        };
        /**
         * Detailed description about the behaviour
         */
        _this.appendent = function () {
            _this.push(function (_) { return "appendent"; });
        };
        /**
         * The list of labels of the behaviour
         */
        _this.labelList = function () {
            _this.push(function (_) { return "labelList"; });
        };
        /**
         * The behaviour xml
         */
        _this.behaviour = function () {
            _this.push(function (_) { return "behaviour"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Behaviour;
}(Array));
exports.Behaviour = Behaviour;
//# sourceMappingURL=Behaviour.js.map